import { Component, PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";
import { Panel } from "react-bootstrap";

type Props = {
  label?: {
    openId?: string;
    closeId?: string;
  };
};

type State = $TSFixMe;

class More extends Component<PropsWithChildren<Props>, State> {
  /* istanbul ignore next */
  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.state = { open: false };
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  render() {
    const { children, label } = this.props;
    return (
      <div className="more">
        <button
          id="more"
          type="button"
          className="btn-link btn-action"
          onClick={this.handleOnClick}
        >
          <FormattedMessage
            id={
              this.state.open
                ? label?.closeId || "global.less"
                : label?.openId || "global.more"
            }
          />
        </button>
        {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
        <Panel expanded={this.state.open} onToggle>
          <Panel.Collapse>
            <Panel.Body>{children}</Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}

export default More;
